/*---------------------------
| ActionTypes
---------------------------*/
export const actionTypes = {
    CC_SELECT_NEXT: "CC: next",
    CC_SELECT_PREVIOUS: "CC: previous",
    CC_SET_IS_ANIMATING: "CC: setIsAnimating"
};
